// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"cc356680","126":"18f7dd6b","171":"069d99f5","278":"25848794","416":"568b94ec","443":"8b5c7754","775":"5b8fdf3f","895":"ecdfe481"}[chunkId] + ".chunk.js";
};